<template>
  <StandardLayout>
    <v-sheet class="mx-12 my-6" rounded slot="main">
      <!-- <h1 class="cal-sans-regular mb-3">Landing Page</h1> -->
      <h1 class="outfit-regular mb-3">Realm Account</h1>
      <v-divider></v-divider>
      <v-card>
        <v-card-text>
          {{ profile }}
        </v-card-text>
      </v-card>
    </v-sheet>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'
export default {

  name: 'RealmAccount',

  components: {
    StandardLayout,
  },

  data() {
    return {
      // sparks: 0
    }
  },

}
</script>
